import { useMutation, useQueryClient } from 'react-query'
import { message } from 'antd'
import { postJSON } from 'common/services/api'

type UseServiceRecordDocumentRemoveProps = {
  residentId: string
}

type UseServiceRecordDocumentRemoveReturn = {
  removeDocument: (recordId: string, documents: string[]) => Promise<void>
  isRemoving: boolean
}

export const useServiceRecordDocumentRemove = ({
  residentId
}: UseServiceRecordDocumentRemoveProps): UseServiceRecordDocumentRemoveReturn => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async ({
      recordId,
      documents
    }: {
      recordId: string
      documents: string[]
    }) => {
      await postJSON({
        url: `/v6/residents/service-records/${recordId}`,
        method: 'PATCH',
        json: { documents }
      })
    },
    {
      onSuccess: () => {
        message.success('Document removed')
        queryClient.invalidateQueries(['service-records', residentId])
      },
      onError: (error: any) => {
        message.error(error?.message || 'Failed to remove document')
      }
    }
  )

  const removeDocument = async (recordId: string, documents: string[]) => {
    await mutation.mutateAsync({ recordId, documents })
  }

  return {
    removeDocument,
    isRemoving: mutation.isLoading
  }
}
